import Cookies from 'js-cookie';

export default class VoteHelpful {
    constructor() {
        this.initListeners();
    }

    initListeners() {
        const id = $('.js-post-block').data('id');
        let vote = Cookies.get(`blog_helpful_vote_${id}`);

        const $upVote = $('.js-up-vote').on('click', () => {
            $upVote.removeClass('active');
            $downVote.removeClass('active');

            let clear;
            if (vote === 'yes') {
                // clear vote
                clear = true;
                vote = null;
            } else {
                $upVote.addClass('active');
                vote = 'yes';
            }
            $.ajax({
                url: '/wp-json/cloroxpro/v1/blog/upvote',
                method: 'POST',
                data: {
                    id,
                    clear,
                },
            });
        });
        const $downVote = $('.js-down-vote').on('click', () => {
            $upVote.removeClass('active');
            $downVote.removeClass('active');

            let clear;
            if (vote === 'no') {
                clear = true;
                vote = null;
            } else {
                $downVote.addClass('active');
                vote = 'no';
            }
            $.ajax({
                url: '/wp-json/cloroxpro/v1/blog/downvote',
                method: 'POST',
                data: {
                    id,
                    clear,
                },
            });
        });

        // set initial state
        if (vote && !$.isEmptyObject(vote)) {
            if (vote === 'yes') {
                $upVote.addClass('active');
            } else {
                $downVote.addClass('active');
            }
        }
    }
}
